import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MED_FLOW, MED_SKU } from "src/utils/medEligibility";

type RecommendationContextState = {
  recommendedMedTier?: MED_SKU;
  eligibleMedTiers?: Array<MED_SKU>;
  flow?: MED_FLOW;
};

const initialState: RecommendationContextState = {};

const recommendationContextSlice = createSlice({
  name: "recommendationContext",
  initialState,
  reducers: {
    setRecommendationContext(
      state,
      action: PayloadAction<RecommendationContextState>
    ) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setRecommendationContext } = recommendationContextSlice.actions;

export default recommendationContextSlice;
